<template>
  <div>
    <div class="columns is-vcentered is-border-bottom has-bg-light">
      <div class="column is-size-6">
        {{sellers.length}} Vendeur(s)
      </div>
      <div class="column is-narrow" v-if="currentUser">
        <router-link class="has-text-grey is-uppercase is-size-6"
                    :to="{name: 'UserCreate', query: {manager: currentUser.pk, company: userCompanyPk}}">
          <span class="icon"><i class="fal fa-user-plus"></i></span>
          <span>Créer un utilisateur</span>
        </router-link>
      </div>
      <div v-if="isAdmin" class="column is-narrow">
        <a @click="newMember" class="has-text-grey is-uppercase is-size-6">
          <span class="icon"><i class="fal fa-plus"></i></span>
          <span>Ajouter un membre</span>
        </a>
      </div>
    </div>
    <table
      class="table is-fullwidth is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right"
      v-if="sellers && sellers.length">
      <thead>
      <tr class="is-size-6">
        <th>Membres</th>
        <th v-if="!currentUser.is_external">
          Objectifs CA {{currentYear}}
        </th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(s, i) in sellers" :key="s.email" class="is-size-6">
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'UserVue', params: {id: s.pk}}" class="fullLink" v-if="s.pk">
            <avatar :item="s" :i="i" class="is-margin-right-xsmall"></avatar>
            <span>{{s.last_name}} {{s.first_name}}</span>
          </router-link>
          <span v-else>{{s.last_name}} {{s.first_name}}</span>
        </td>
        <td v-if="!currentUser.is_external">
          <div class="" v-if="s.goals && s.goals.length && sellerGoal(s)">
            <div class="has-text-grey is-size-6">{{sellerGoal(s).goal | prettyPrice }} {{$currency}}</div>
            <progress class="progress is-success is-small" :value="goalProgress(s)" max="100">{{goalProgress(s)}}%
            </progress>
          </div>
        </td>
        <td class="actions has-text-right">
          <display-button-list :buttons="buttonList" :data="s"
              :openUp="{'position': i, 'total': sellers.length}">
          </display-button-list>
          <!-- <a @click="deleteSeller(s)" class="button is-circle is-white is-small"
             :class="{'disabled': s._removed }">
            <i class="fal fa-trash"></i>
          </a> -->
          <!-- <a @click="updateSeller(s)" class="button is-circle is-white is-small"
             :class="{'disabled': s._removed }">
            <i class=" fas fa-edit"></i>
          </a> -->
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import { StatsMx } from '@/mixins'
  import { isNil } from 'lodash'
  import moment from 'moment'

  export default {
    name: 'UserTeamList',
    mixins: [StatsMx],
    data () {
      return {
        buttonList: [
          {
            action: (id, data) => {
              this.deleteSeller(data)
            },
            icon: 'fas fa-user-minus',
            text: 'Retirer de l\'équipe',
            needProfile: ['admin', 'manager']
          },
          {
            routeName: 'UserEdit',
            icon: 'fas fa-user-edit',
            text: 'Modifier l\'utilisateur',
            needProfile: ['admin', 'manager', 'manager_ext']
          }
        ],
        sellerModel: [],
        freeSellers: [],
        sellers: [],
        toRemove: [],
        isAdding: false
      }
    },
    props: {
      sourceSellers: {
        type: Array,
        required: true
      },
      sourceUser: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isExternal', 'isAdmin']),
      currentUser () {
        return this.sourceUser
      },
      userCompanyPk () {
        return this.currentUser.company ? this.currentUser.company.pk || this.currentUser.company : null
      },
      getFreeSellersFilters () {
        let company
        if (this.currentUser.company) {
          company = this.currentUser.company.pk || this.currentUser.company
        }
        const filters = {
          has_manager: 0,
          company: company,
          profil_type: (this.currentUser.company) ? 'seller_ext' : 'seller'
        }
        return filters
      },
      currentYear () {
        return moment().format('YYYY')
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION' && params.type === 'seller') {
            this.addSeller(results.entities)
          }
        }
      }
    },
    methods: {
      getFreeSellers () {
        this.$api.userService.get(this.getFreeSellersFilters).then(r => {
          this.freeSellers = r.data.items
        })
      },
      deleteSeller (seller) {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes-vous sur de vouloir retirer cet utilisateur de l\'équipe ?',
          confirmButtonText: 'Retirer'
        }).then(r => {
          if (r.value) {
            let sellerPk = seller.pk || seller.user
            this.$set(seller, '_removed', true)
            let index = this.sellers.findIndex(x => x.email === seller.email)
            this.$api.groupService.delete(this.currentUser.pk, sellerPk).then(r => {
              this.sellers.splice(index, 1)
              this.getFreeSellers()
              this.$emit('removeSeller', sellerPk)
              this.$notify({
                type: 'is-success',
                text: 'Le vendeur a bien été supprimé du manager.'
              })
            }).catch(err => {
              console.log(err)
              this.$notify({
                type: 'is-danger',
                text: 'Impossible de supprimer ce vendeur du manager.'
              })
            })
          }
        })
      },
      addSeller (results) {
        this.isAdding = true
        let users = results.map(x => x.pk)
        this.$api.groupService.post(this.sourceUser.pk, {users}).then(r => {
          for (let newSeller of r.data) {
            newSeller.pk = newSeller.user
            this.sellers.unshift(newSeller)
            this.$emit('addSeller', newSeller.user)
          }
          this.getFreeSellers()
          this.isAdding = false
          this.$notify({
            type: 'is-success',
            text: 'Vendeur(s) ajouté(s) au manager.'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible d\'ajouter ce(s) vendeur(s) à ce manager.'
          })
        })
      },
      newMember () {
        let userPk = this.sellers.map(x => x.pk)
        let freeSellersPk = this.freeSellers.map(x => x.pk)
        let params = {
          excludes: userPk,
          mode: 'append',
          includes: freeSellersPk,
          type: 'seller'
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      goalProgress (seller) {
        if (seller.is_external) return
        if (!seller._sales || !seller.goals) {
          return null
        }
        let sales = seller._sales.slice().filter(x => {
          return moment(x.reservation_date).format('YYYY') === this.currentYear && x.seller === seller.pk
        })
        let stats = this.computedSalesData(sales)

        let currentYearCA = stats.CA
        if (!stats.CA) return null

        let sellerGoal = seller.goals.find(x => {
          return x.year.toString() === this.currentYear.toString()
        })
        let progress = parseFloat(currentYearCA) / parseFloat(sellerGoal.goal)
        progress = progress * 100
        return parseInt(progress)
      },
      sellerGoal (user) {
        if (isNil(user.goals)) {
          return null
        }
        return user.goals.find(x => {
          return x.year.toString() === this.currentYear.toString()
        })
      }
    },
    created () {
      this.getFreeSellers()
      this.sellers = this.sourceSellers.slice()
      /*
      let startDate = moment().startOf('year')
      let endDate = moment().endOf('year')
      this.sellers.forEach(seller => {
        const params = {
          entityKey: 'USER',
          entityPk: seller.pk,
          startDate: startDate,
          endDate: endDate
        }
        this.getEntitySalesStats(params).then(res => {
          // let rawSales = res.data.sales
        })
      })
      */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserTeamList.vue